'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Immutable = require('Immutable');

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _TimeRange = require('MeetingsBase/models/TimeRange');

var _TimeRange2 = _interopRequireDefault(_TimeRange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaults = {
  id: null,
  busyTimes: (0, _Immutable.List)(),
  offline: false,
  firstName: null,
  lastName: null,
  email: null
};

var UserBusyTimes = function (_Record) {
  _inherits(UserBusyTimes, _Record);

  function UserBusyTimes() {
    _classCallCheck(this, UserBusyTimes);

    return _possibleConstructorReturn(this, (UserBusyTimes.__proto__ || Object.getPrototypeOf(UserBusyTimes)).apply(this, arguments));
  }

  _createClass(UserBusyTimes, null, [{
    key: 'from',
    value: function from(json) {
      return new UserBusyTimes({
        id: json.meetingsUser.id,
        busyTimes: (0, _Immutable.List)(json.busyTimes.map(function (b) {
          return _TimeRange2.default.from(b);
        })),
        offline: json.offline,
        firstName: (0, _getIn2.default)(['meetingsUser', 'userProfile', 'firstName'], json),
        lastName: (0, _getIn2.default)(['meetingsUser', 'userProfile', 'lastName'], json),
        email: (0, _getIn2.default)(['meetingsUser', 'userProfile', 'email'], json)
      });
    }
  }]);

  return UserBusyTimes;
}((0, _Immutable.Record)(defaults));

exports.default = UserBusyTimes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/models/UserBusyTimes.js
// module id = 330
// module chunks = 0